import { render } from "./PrintInvoiceWordsDesign1.vue?vue&type=template&id=03e2b168&scoped=true"
import script from "./PrintInvoiceWordsDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceWordsDesign1.vue?vue&type=script&lang=js"

import "./PrintInvoiceWordsDesign1.vue?vue&type=style&index=0&id=03e2b168&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e2b168"]])

export default __exports__